import { sessionOptions } from '../../../auth/session';
import type { QwaSession } from '../../../auth/types';
import Cookie from 'js-cookie';
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { createApiDefaults } from './base';

// AUTH0_TODO to be cleanup | good example of toolkit usage
export const sessionApi = createApi({
  ...createApiDefaults,
  reducerPath: 'apiService', // this is a legacy name. if this is changed, everyone will be logged out
  tagTypes: ['session'],
  endpoints: (builder) => ({
    // createSession: builder.mutation<QwaSession, LoginRequestBodyType>({
    //   query: (data) => ({
    //     url: 'auth/login',
    //     method: 'POST',
    //     data,
    //   }),
    //   onQueryStarted: async (createSessionReq, { dispatch, queryFulfilled }) => {
    //     //
    //     try {
    //       const { data: session } = await queryFulfilled;
    //       const patchResult = dispatch(
    //         sessionApi.util.updateQueryData('getSession', undefined, (draft) => {
    //           // since redux uses shallow equality comparisons,
    //           // we should copy over the properties
    //           Object.assign(draft, session);
    //         })
    //       );
    //     } catch {
    //       // an error occurred executing the query, so nothing to do
    //     }
    //   },
    // }),
    getSession: builder.query<QwaSession, void>({
      query: () => ({ url: 'auth/session', method: 'GET' }),
      providesTags: ['session'],
      keepUnusedDataFor: 60, // seconds
      // redux doesn't know about the cookie
      // so write a fn to use a custom cache key
      serializeQueryArgs: () => {
        const sessionCookie = Cookie.get(sessionOptions.cookieName);
        // can't be undefined/null
        return sessionCookie || '';
      },
    }),
    // updateSession: builder.mutation<QwaSession, UpdateOktaSessionRequest | UpdateLookerSessionRequest>({
    //   query: (data) => ({
    //     url: 'auth/session',
    //     method: 'PUT',
    //     data,
    //   }),
    //   onQueryStarted: async (updateSessionReq, { dispatch, queryFulfilled }) => {
    //     //
    //     try {
    //       const { data: session } = await queryFulfilled;
    //       const patchResult = dispatch(
    //         sessionApi.util.updateQueryData('getSession', undefined, (draft) => {
    //           // since redux uses shallow equality comparisons,
    //           // we should copy over the properties
    //           Object.assign(draft, session);
    //         })
    //       );
    //     } catch {
    //       // an error occurred executing the query, so nothing to do
    //     }
    //   },
    // }),
    deleteSession: builder.mutation<unknown, void>({
      query: () => ({
        url: 'auth/logout',
        method: 'DELETE',
      }),
      invalidatesTags: ['session'],
    }),
  }),
});

export const {
  useDeleteSessionMutation,
  useGetSessionQuery,
  useLazyGetSessionQuery,
  usePrefetch,
  middleware,
  reducer,
  endpoints,
  util,
  reducerPath,
} = sessionApi;
export default sessionApi;
